import styled from "styled-components";

export const DuotoneWrapper = styled.div<{
  $objectFit: string;
  $width?: number | string;
  $height?: number | string;
  $backgroundColor: string;
}>`
  position: relative;
  overflow: hidden;
  border-radius: inherit;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  width: ${({ $width }) =>
    typeof $width === "number" ? `${$width}px` : ($width ?? "100%")};
  height: ${({ $height }) =>
    typeof $height === "number" ? `${$height}px` : ($height ?? "auto")};
  min-height: ${({ $height }) => ($height == null ? "150px" : 0)};
  display: block;
`;

export const DuotoneImg = styled.img<{
  $objectFit: string;
  $mixBlendMode?: string;
  $filter?: string;
  $grayscale?: boolean;
}>`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit }) => $objectFit};
  vertical-align: middle;
  border-radius: inherit;
  mix-blend-mode: ${({ $mixBlendMode }) => $mixBlendMode ?? "normal"};
  filter: ${({ $filter }) => $filter ?? "none"};
`;

export const DuotoneOverlay = styled.div<{
  $opacity: number;
  $backgroundColor: string;
}>`
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  mix-blend-mode: color;
  opacity: ${({ $opacity }) => $opacity};
`;

export const SvgFilterDefs = styled.svg`
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
